module.exports = __webpack_public_path__ + "static/img/Longi_Logo.22aa8ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Longi_Logo.jpg
// module id = Amn+
// module chunks = 39